// src/components/SearchProgram.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildingColumns, faFile } from '@fortawesome/free-solid-svg-icons';

const SearchProposed = ({ proposed, college }) => {
  return (
    <>
      <div className="fs-6 fw-bold">(PROPOSED) {proposed.checksheetName}</div>
      <div className="text-gray-6 d-flex align-items-center font-small">
        <FontAwesomeIcon
          icon={faBuildingColumns}
          className="me-1 text-gray-6"
          width="16px"
        />
        {college?.description}
      </div>

      <div className="text-gray-6 d-flex align-items-center font-small">
        <FontAwesomeIcon
          icon={faFile}
          className="me-1 text-gray-6"
          width="16px"
        />
        {proposed.acadplan}
        {proposed.acadSubPlanCode && <span> / {proposed.acadSubPlanCode}</span>}
      </div>
    </>
  );
};

export default SearchProposed;
